import React from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import { Button } from "@mui/material";
import NoDataScreen from "../ui/temp-screens/NoDataScreen"

const EditarDescripcionServicioCotizacion = ({ open, onClose, description, setDescripcion, defaultDescription, customizedDescriptions }) => {
  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      title="Editar descripción de servicio"
      centered
    >
      {/* <div className="flex flex-col gap-1 mb-1">
        <span className="text-xs">Descripciones preestablecidas</span>
        <span className="text-[10px] text-gray-500">Selecciona una descripción preestablecida y modifícala, ten en cuenta que si haces click en una descripción no podras volver a ver la que tenías anteriormente.</span>
      </div>
      <div className="flex items-center flex-row gap-2 border border-gray-200 rounded-lg bg-gray-50 mb-2 p-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        <button 
          className="bg-[#ff6400] text-white px-2 py-0 rounded-lg whitespace-nowrap"
          onClick={() => {setDescripcion(defaultDescription)}}
        >
          <span className="text-[10px]">Descripción del plan por defecto</span>
        </button>
        {customizedDescriptions && customizedDescriptions.length > 0 && customizedDescriptions.map((d, index) => (
          <button 
            className="bg-[#ff6400] text-white px-2 py-0 rounded-lg whitespace-nowrap"
            onClick={() => {setDescripcion(d.description)}}
          >
            <span className="text-[10px]">{d.title}</span>
          </button>
        ))}
      </div> */}

      <div className="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50">
        <div className="px-4 py-2 bg-white rounded-t-lg ">
          <textarea
            id="comment"
            rows="20"
            value={description || defaultDescription}
            onChange={(e) => setDescripcion(e.target.value)}
            className="w-full px-0 text-xs text-gray-900 bg-white border-0  focus:ring-0 "
            placeholder="Escribe una descripción"
            required
          />
        </div>
        <div className="flex items-center justify-center px-3 py-2 border-t ">
          <button
            type="button"
            onClick={() => onClose()}
            className="inline-flex items-center  text-center py-2.5 px-4 text-xs font-medium  text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200  hover:bg-blue-800"
          >
            Guardar
          </button>
        </div>
      </div>
    </ModalInDrawer>
  );
};

export default EditarDescripcionServicioCotizacion;
